module.exports = __webpack_public_path__ + "ece7bf6ca6f021b4e665e0e633459258.svg";